import { Injectable } from '@angular/core';
import { BaseProvider } from '../../../../shared/providers/base-provider';
import { OgcNotifier } from './ogc-notifier';
import { OgcState } from './ogc-state';

@Injectable()
export class OgcProvider extends BaseProvider<OgcNotifier, OgcState> {
  constructor() {
    super(OgcNotifier);
  }
}
